import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../components/private/pagination";

const Curriculum = () => {
  const { token, authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [curriculums, setCurriculums] = useState([]);
  const [loading, setLoading] = useState(true);

  // Buscador
  const [filter, setFilter] = useState({
    searchQuery: "",
    searchBy: "document",
  });

  // Paginación
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  useEffect(() => {
    if (!token) return;

    const loadData = async () => {
      setLoading(true);

      const data = await authFetch(ENDPOINTS.getCurriculum);

      if (data.success) setCurriculums(data.data);
      else setCurriculums([]);

      setLoading(false);
    };

    loadData();
  }, [token, authFetch]);

  const handleViewCV = (id_curriculum) => {
  const url = `${ENDPOINTS.curriculumcertificate}?id_curriculum=${id_curriculum}`;
  window.open(url, "_blank");
};


  const handleFilterChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
    setCurrentPage(1);
  };

  const handleSearch = () => {
    const query = filter.searchQuery.toLowerCase();

    return curriculums.filter((item) => {
      let match = false;

      switch (filter.searchBy) {
        case "document":
          match = item.document.toString().toLowerCase().includes(query);
          break;

        case "first_name":
          match = item.first_name.toLowerCase().includes(query);
          break;

        case "last_name":
          match = item.last_name.toLowerCase().includes(query);
          break;

        default:
          match = true;
      }

      return match;
    });
  };

  const filtered = handleSearch();
  const totalPages = Math.ceil(filtered.length / recordsPerPage);
  const currentRecords = filtered.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };


  if (loading) return <p>Cargando curriculums...</p>;

  return (
    <div className="container mt-4 p-4">

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Listado de hojas de vida</h2>
      </div>

      {/* BUSCADOR */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label className="m-1">Buscar</label>
          <input
            type="text"
            name="searchQuery"
            className="form-control"
            value={filter.searchQuery}
            onChange={handleFilterChange}
          />
        </div>

        <div className="col-md-4">
          <label className="m-1">Buscar por</label>
          <select
            className="form-select"
            name="searchBy"
            value={filter.searchBy}
            onChange={handleFilterChange}
          >
            <option value="document">Documento</option>
            <option value="first_name">Primer Nombre</option>
            <option value="last_name">Primer Apellido</option>
          </select>
        </div>
      </div>

      {/* TABLA */}
      {currentRecords.length > 0 ? (
        <>
          <table className="table table-hover">
            <thead className="table-secondary">
              <tr>
                <th>Documento</th>
                <th>Colaborador</th>
                <th>Correo</th>
                <th>Celular</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {currentRecords.map((item) => (
                <tr key={item.Id}>
                  <td>{item.document}</td>
                  <td>{item.first_name} {item.second_name} {item.last_name} {item.second_last_name}</td>
                  <td>{item.email}</td>
                  <td>{item.number_phone}</td>
                  <td>
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-outline-purple btn-sm me-2"
                        onClick={() => handleViewCV(item.Id)}
                      >
                        <i className="bi bi-eye-fill me-1"></i> Ver PDF
                      </button>


                      <button
                        className="btn btn-secondary btn-sm"
                        onClick={() =>
                          navigate(`/session/curriculum/updateCurriculum/${item.Id}`)
                        }
                      >
                        <i className="bi bi-pencil-square me-1"></i>
                        Modificar
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* PAGINACIÓN */}
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />
        </>
      ) : (
        <p>No hay curriculums registrados.</p>
      )}

    </div>
  );
};

export default Curriculum;
